import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'Home',
    component: () => import(/* webpackChunkName: "chunk-vendor.23532" */ '../views/Home.vue')
  },
  {
    path: '/sHopErTynSaWw',
    component: () => import(/* webpackChunkName: "chunk-vendor.6424534" */ '../views/Login')
  },
  {
    path: '/ponuda',
    name: 'Ponuda',
    component: () => import(/* webpackChunkName: "chunk-vendor.2734322" */ '../views/Ponuda.vue'),
    props: true,
    children: [
      {
        path: '',
        redirect: 'dnevne-garniture'
      },
      {
        path: ':dob',
        component: () => import(/* webpackChunkName: "chunk-vendor.2734322" */ '../views/Dobavljac.vue'),
        props: true
      },
      {
        path: ':dob/:id*',
        name: 'Item',
        component: () => import(/* webpackChunkName: "chunk-vendor.2734322" */ '../views/Item.vue'),
        props: true
      },
      {
        path: '/moji-artikli',
        component: () => import(/* webpackChunkName: "chunk-vendor.2734322" */ '../views/MojiArt.vue'),
        props: true
      }
    ]
  },
  {
    path: '/nacini-placanja',
    name: 'Nacin',
    component: () => import(/* webpackChunkName: "chunk-vendor.23532" */ '../views/Nacin.vue')
  },
  {
    path: '/kontakt',
    name: 'Kontakt',
    component: () => import(/* webpackChunkName: "chunk-vendor.23532" */ '../views/Kontakt.vue')
  },
  {
    path: '/dZpnOaCcAR',
    name: 'dZpnOaCcAR',
    component: () => import(/* webpackChunkName: "chunk-vendor.7452534" */ '../views/Admin.vue'),
    props: true,
    children: [
      {
        path: 'artikli',
        component: () => import(/* webpackChunkName: "chunk-vendor.7452534" */ '../views/AdminArtikli.vue'),
        props: true
      },
      {
        path: 'novi_artikal',
        component: () => import(/* webpackChunkName: "chunk-vendor.7452534" */ '../views/AdminNovi.vue'),
        props: true
      },
      {
        path: 'izm/:id',
        component: () => import(/* webpackChunkName: "chunk-vendor.7452534" */ '../views/AdminIzmjena.vue'),
        props: true
      },
      {
        path: 'porudzbe',
        component: () => import(/* webpackChunkName: "chunk-vendor.7452534" */ '../views/AdminPor.vue'),
        props: true
      },
      {
        path: 'pracenje',
        component: () => import(/* webpackChunkName: "chunk-vendor.7452534" */ '../views/AdminView.vue'),
        props: true
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
